import React, { useState } from 'react';
import { applicationAPI } from '../api/recruitmentApi';

const EmailComposer = ({ application, onClose, onSend }) => {
  const [emailData, setEmailData] = useState({
    type: 'interview_invitation',
    customMessage: ''
  });
  const [sending, setSending] = useState(false);

  const templates = {
    rejection: {
      subject: 'Thank you for your application',
      preview: `Dear ${application.firstName},\n\nThank you for your interest in the ${application.job?.title} position. After careful consideration, we have decided to move forward with other candidates whose qualifications more closely match our current needs.\n\nWe appreciate the time you invested in the application process and wish you the best in your job search.`
    },
    interview_invitation: {
      subject: 'Interview Invitation',
      preview: `Dear ${application.firstName},\n\nWe are pleased to invite you for an interview for the ${application.job?.title} position. We were impressed with your qualifications and would like to learn more about your experience.\n\nPlease let us know your availability for the interview.`
    },
    offer: {
      subject: 'Job Offer',
      preview: `Dear ${application.firstName},\n\nCongratulations! We are delighted to offer you the position of ${application.job?.title}. We believe your skills and experience will be a great addition to our team.\n\nPlease find the detailed offer letter attached.`
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSending(true);
      const response = await applicationAPI.sendEmail(application.id, emailData);
      console.log('✅ Email sent successfully:', response);
      alert('Email sent successfully!');
      onSend();
      onClose();
    } catch (error) {
      console.error('❌ Failed to send email:', error);
      const errorMessage = error.response?.data?.error || error.response?.data?.details || error.message || 'Failed to send email';
      alert(`Failed to send email: ${errorMessage}`);
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold">Send Email</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Recipient */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              To
            </label>
            <div className="px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg">
              {application.firstName} {application.lastName} ({application.email})
            </div>
          </div>

          {/* Email Type */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Template
            </label>
            <select
              value={emailData.type}
              onChange={(e) => setEmailData({ ...emailData, type: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            >
              <option value="interview_invitation">Interview Invitation</option>
              <option value="rejection">Rejection</option>
              <option value="offer">Offer Letter</option>
            </select>
          </div>

          {/* Template Preview */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Template Preview
            </label>
            <div className="p-4 bg-gray-50 border border-gray-300 rounded-lg">
              <p className="font-medium mb-2">{templates[emailData.type].subject}</p>
              <p className="text-sm text-gray-700 whitespace-pre-wrap">
                {templates[emailData.type].preview}
              </p>
            </div>
          </div>

          {/* Custom Message */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Custom Message (Optional)
            </label>
            <textarea
              value={emailData.customMessage}
              onChange={(e) => setEmailData({ ...emailData, customMessage: e.target.value })}
              rows={6}
              placeholder="Add additional message or customize the template..."
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Warning for rejection emails */}
          {emailData.type === 'rejection' && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <p className="text-sm text-yellow-800">
                ⚠️ This will send a rejection email and update the application status to "rejected".
              </p>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex gap-3 pt-4">
            <button
              type="submit"
              disabled={sending}
              className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition disabled:opacity-50"
            >
              {sending ? 'Sending...' : 'Send Email'}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailComposer;
